// https://developers.ringcentral.com/guide/messaging/sms/sending-images
export const SUPPORTED_MMS_MIME_TYPES_IN_LOWERCASE = [
  'image/tiff',
  'image/gif',
  'image/jpeg',
  'image/bmp',
  'image/png',
  'image/svg+xml',
  'text/vcard',
  'video/mp4',
  'video/mpeg',
  'audio/mpeg',
  'application/zip',
];
